export default __webpack_public_path__ + "static/media/Instagram.f9f21799.png";